import { render } from "./AllLogs.vue?vue&type=template&id=b922392c"
import script from "./AllLogs.vue?vue&type=script&lang=js"
export * from "./AllLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__